import { QUICK_ENTRY_SELECTION_KEYS } from 'features/quick-entry/constants';

export const buildFormParams = formData => ({
  candidateName: formData?.name || '',
  candidateEmail: formData?.email || '',
  files:
    Array.isArray(formData?.files) &&
    formData?.files.map(file => ({
      createdAt: file?.created_at,
      id: file?.id,
      name: file?.file_name,
      sizeInBytes: file?.size_in_bytes,
      typeId: file?.file_type_id || file?.fileType?.id,
      updatedAt: file?.updated_at,
      url: file?.url
    })),
  notes: formData?.notes || null,
  typeId: QUICK_ENTRY_SELECTION_KEYS.candidate
});

export const mapQuickEntryFiles = (files = []) => {
  return files.map(file => ({
    id: file?.id,
    file_name: file?.name,
    fileType: { id: file?.typeId },
    url: file?.url
  }));
};
